import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useUser from 'hooks/userHooks';
import { getRedirectPath } from '../constants/routes';

/**
 * RedirectHandler component that automatically redirects agency 36 users
 * from v3 routes to appropriate v2 routes
 */
const RedirectHandler = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isLoading } = useUser();

  useEffect(() => {
    // Don't redirect while loading user data
    if (isLoading || !user) {
      return;
    }

    const redirectPath = getRedirectPath(location.pathname, user.agency_id);
    
    if (redirectPath) {
      navigate(redirectPath, { replace: true });
    }
  }, [location.pathname, user, isLoading, navigate]);

  // Don't render children if we're redirecting
  if (!isLoading && user) {
    const redirectPath = getRedirectPath(location.pathname, user.agency_id);
    if (redirectPath) {
      return null; // Don't render anything while redirecting
    }
  }

  return children;
};

export default RedirectHandler; 